module.exports = __webpack_public_path__ + "static/media/storyy.2338d1f5.png";